import {
  useMutation, UseMutationOptions, UseMutationResult,
} from 'react-query';
import { useTranslation } from 'react-i18next';
import { Dayjs } from 'dayjs';
import {
  appendQueryParamIfNotEmpty, downloadFile, formatDate,
} from '../../../constants/hookConstants';
import closableEnqueueSnackbar from '../../../components/closableEnqueueSnackbar/closableEnqueueSnackbar';
import { TypeOfMutationFunction } from '../../../interfaces/query/queryHook.type';

interface GetExportKeywordTableInterface{
    from: Dayjs | null,
    to: Dayjs | null,
    page: number,
}

export const useGetExportKeywordTable = (
  params : GetExportKeywordTableInterface,
) => {
  const { t } = useTranslation();

  const queryParams = new URLSearchParams();

  appendQueryParamIfNotEmpty(queryParams, 'from', formatDate(params.from));
  appendQueryParamIfNotEmpty(queryParams, 'to', formatDate(params.to));
  appendQueryParamIfNotEmpty(queryParams, 'page', params.page);
  appendQueryParamIfNotEmpty(queryParams, 'rows', 1000);

  const mutationFunction: TypeOfMutationFunction = async (acceptHeader: string) => {
    const url = `form-submission/keyword/count?${queryParams}`;
    await downloadFile(url, acceptHeader, t);
  };

  const options: UseMutationOptions<void, unknown, string> = {
    onError: () => {
      closableEnqueueSnackbar(t('somethingWentWrong'), 'error');
    },
  };

  const mutation: UseMutationResult<void, unknown, string> = useMutation(
    mutationFunction,
    options,
  );

  return mutation;
};
